<template>
    <div class="app-het">
      <div v-if="debug_show_page_name==true" style="color:green;">page_0041_master_user_detail_bulk_edit</div>
        <app-header>esma</app-header>
        <div :class="'container ' +pageContainerSize">
          <title-and-slot title="ユーザ（一括編集）" >
          </title-and-slot>
            <div class="row" style="margin-bottom:10px;">
            <div class="col-xs-4">
              <button class="btn btn-primary" style="width: 25%;float: left;margin-left: -10px;min-width:100px;" @click="backToList" >＜　戻る</button>
            </div>
            </div>
            <div class="row" style="margin-bottom:10px;">
                 <div class="col-xs-4">
                    <field-box   v-for="f in formFields.col1"  v-bind:key="f.id" v-bind:data="f"  :read="readOnly" :val="values[f.id]"></field-box>
                 </div>
            </div>
            <div class="row" style="margin-bottom:10px;">
              <div class="col-xs-4">
               <button :disabled="false" class="btn btn-primary" style="min-width:100px;float: right;margin-right: -10px;background: #92D050;border-color:#92D050;" @click="onLocalSaveBulkDevEmbedded" >登録</button>
              </div>
             </div>
        </div>
        <confirmation-modal tag="confirmBulkDeviceEmbeddedInformationAddCheck" @done="onBulkDeviceEmbeddedInformationAddCheckConfirm" />
        <!-- <confirmation-modal tag="deleteMasterUserBulkModal" @done="onConfirmDelete" /> -->
    </div>
</template>

<script>
import Vue from 'vue';
import moment from 'moment';
import { fields, filed_types } from '@/rules/fields_master_user';
import { utils } from '@/libs/utils';
import _debug from 'debug';
var mdebug = _debug('esma:master_user');
import fieldBoxes from '@/components/form-field';
import acl from '@/rules/acl_rules';
import mixinPageCommon from '@/mixins/mixin_page_common';
import mixinDatasource from '@/mixins/mixin_datasource';
import { bus } from '@/libs/bus';
export default {
  mixins: [mixinPageCommon,mixinDatasource],
    components: {
    'field-box': fieldBoxes,
  },
  data() {
    return {
      api_name:"master_user",
      page_acl: acl.generic
    };
  },
  computed: {
    fieldList() {
      return fields;
    },
    typeList() {
      return filed_types;
    },
    formFields() {
      return {
        col1:[
          utils.extend(_.clone(fields.user_id), {disabled: true , read_only:true,error_if_blank:false,}),
          utils.extend(_.clone(fields.user_shimei), {disabled: true , read_only:true,error_if_blank:false,}),
          utils.extend(_.clone(fields.role), {disabled: true , read_only:true,error_if_blank:false,}),
          utils.extend(_.clone(fields.company), {error_if_blank:false,}),
          utils.extend(_.clone(fields.department), {error_if_blank:false,}),
          utils.extend(_.clone(fields.team), {error_if_blank:false,}),
          utils.extend(_.clone(fields.last_login_date),  { disabled: true , read_only:true,error_if_blank:false,}),
          utils.extend(_.clone(fields.password), {disabled: true , read_only:true,error_if_blank:false,}),
          utils.extend(_.clone(fields.mail_address), {disabled: true , read_only:true,error_if_blank:false,}),
          utils.extend(_.clone(fields.login_failure_count), { disabled: true , read_only:true,error_if_blank:false,}),
        ],
      }
    }
  },
  methods: {
    onLocalSaveBulkDevEmbedded(){
      console.log("onLocalSave")
      bus.$emit("confirmBulkDeviceEmbeddedInformationAddCheck",{
        message: "",
        title: "本当に登録してよろしいでしょうか。",
        yes_label: "完了",
        no_label: "キャンセル",
        yes_color:"primary",
        no_color:"",
        model_height:"50"
      });
    },
    onBulkDeviceEmbeddedInformationAddCheckConfirm(mode){
      if(mode == "yes"){
        this.read_only = false;
        var list_seq_id = Vue.localStorage.get('bulk_edit_' + this.local_page_id);
        try {
          list_seq_id = JSON.parse(list_seq_id)
          this.$store.state[this.stateCurrentEditing]["approval_status"] = "下書中";
          this.saveBulk(this.api_name,list_seq_id.arr, { from_edit_form: true }, (err)=>{
          })
        } catch (error) {
          this.$notify({
            title: "予期しないエラーが発生し、登録が行えません",
            text:error,
            type: 'error',
            duration: 12000
          })
        }
      }
    },
    backToList(){
      return this.$router.push({ name: "page_0041_master_user", params: {} });
    },
    onConfirmDelete(mode){
      if(mode == "yes"){
        this.commonDelete(this);
      }
    },
    prepareCompanySelection( company, companies, department_and_team, company_field, department_field, team_field, company_field_name, department_field_name ) {


      var selected_company = false;
      var selected_department = company;
      company_field.page_controller_setup({
        on_select: (_selected_company) => {
          selected_company = _selected_company;
          if (selected_company == "") {
            department_field.page_controller_msg({ cmd: "disable" });
            team_field.page_controller_msg({ cmd: "disable" });
          } else {
            var departments = _.uniq(
              _.map(
                _.filter(department_and_team || [], (d) => {
                  return d.company == selected_company;
                }) || [],
                "department"
              ) || []
            );
            departments.unshift("");
            department_field.page_controller_msg({ cmd: "enable" });
            department_field.page_controller_msg({ cmd: "set_value", val: "" });
            team_field.page_controller_msg({ cmd: "set_value", val: "" });
            team_field.page_controller_msg({ cmd: "disable" });
            department_field.page_controller_msg({
              cmd: "set_options",
              options: departments,
              reset: true,
            });
          }
        },
      });
      department_field.page_controller_setup({
        on_select: (_selected_department) => {
          selected_department = _selected_department;
          if (selected_department == "") {
            team_field.page_controller_msg({ cmd: "disable" });
            team_field.page_controller_msg({ cmd: "set_value", val: "" });
          } else {
            var teams = _.uniq(
              _.map(
                _.filter(department_and_team || [], (d) => {
                  return (
                    d.company == selected_company &&
                    d.department == selected_department
                  );
                }) || [],
                "team"
              ) || []
            );
            teams.unshift("");
            team_field.page_controller_msg({ cmd: "enable" });
            team_field.page_controller_msg({cmd:"set_value",val:""})
            team_field.page_controller_msg({
              cmd: "set_options",
              options: teams,
              reset: true,
            });
          }
        },
      });
      company_field.page_controller_msg({
        cmd: "set_options",
        options: _.clone(companies),
      });
      company_field.page_controller_msg({ cmd: "disable" });
      department_field.page_controller_msg({ cmd: "disable" });
      team_field.page_controller_msg({ cmd: "disable" });
      setTimeout(
        () => {
          department_field.page_controller_msg({ cmd: "enable_if_data" });
          team_field.page_controller_msg({ cmd: "enable_if_data" });

          selected_company = this.$store.state[this.stateCurrentRow][company_field.id];
          selected_department = this.$store.state[this.stateCurrentRow][department_field.id];
          if (selected_company && selected_company.length > 0) {
            var departments = _.uniq(
              _.map(
                _.filter(department_and_team || [], (d) => {
                  return d.company == selected_company;
                }) || [],
                "department"
              ) || []
            );
            department_field.page_controller_msg({
              cmd: "set_options",
              options: departments,
              reset: false,
            });
            department_field.page_controller_msg({ cmd: "enable" });
            if (selected_department && selected_department.length > 0) {
              var teams = _.uniq(
                _.map(
                  _.filter(department_and_team || [], (d) => {
                    return (
                      d.company == selected_company &&
                      d.department == selected_department
                    );
                  }) || [],
                  "team"
                ) || []
              );
              team_field.page_controller_msg({
                cmd: "set_options",
                options: teams,
                reset: false,
              });
            }
          }
        },
        this.is_new ? 100 : 500
      );
    },
    startCompanySelection(company){
      if(this.company_selection_started == true){
        return;
      }
      this.company_selection_started  = true;
      if (true) {
        var temp_fields = this.installedFieldList;
        // Load the companies
        this.$ajax.post_cached_queued( "/master_company/list_company_name", {}, (err, _companies) => {
            if (err) {
              this.$notify({
                title: "所管会社のデータが読込めませんでした。",
                text: err,
                type: "error",
                duration: 10000,
              });
              return;
            }
            var companies = [company];
            // Load the departments and teams
            this.$ajax.post_cached_queued( "/master_belongs/list_team_and_department", {}, (err, department_and_team) => {
                if (err) {
                  this.$notify({
                    title: "部署・チームのデータの読込に失敗しました。",
                    text: err,
                    type: "error",
                    duration: 10000,
                  });
                  return;
                }
                this.prepareCompanySelection(
                  company,
                  _.clone(companies),
                  _.clone(department_and_team),
                  temp_fields.company,
                  temp_fields.department,
                  temp_fields.team,
                  "company",
                  "department"
                );
                if (this.is_new == true) {
                    setTimeout(
                      () => {
                        temp_fields.company.page_controller_msg({
                          cmd: "set_value",
                          val: company,
                        });
                      },
                      this.is_new ? 300 : 1000
                    );
                  }
                }
            );
          }
        );
      }
    }
  },
  mounted() {
    this.$store.state[this.stateCurrentEditing] = {};
    this.addHtmlClass(document.body,'blue_bg')
    this.local_page_id = this.$route.params.p_id;
    this.is_new = true;
    // Note, it is not editing a new record, but will emulate it, as the behaivour is the same.
    this.allFields.forEach(f =>{
      this.$store.state[this.stateCurrentRow][f.id] = "";
    })
    setTimeout(() => {
      this.$store.state[this.stateIsEditingNew] = true;
      this.read_only = false;
      this.is_new = true;

      var list_seq_id = Vue.localStorage.get('bulk_edit_' + this.local_page_id);
      try {
        list_seq_id = JSON.parse(list_seq_id)
        var company  = list_seq_id.company;
        console.log('TEST DEBUG 210522 (135 at page_0041_master_user_detail_bulk_edit.vue)[21:57]: ', { company });
        this.startCompanySelection(company)
      } catch (error) {
        this.$notify({
          title: "Error to load 所属会社",
          text:error,
          type: 'error',
          duration: 12000
        })
      }
    }, 300);
  },
  beforeDestroy() {
    this.$store.state[this.stateCurrentEditing] = {};
    this.removeHtmlClass(document.body,'blue_bg')
  },
  beforeMount() {
  }
};

</script>
<style scoped>

input:focus::-webkit-input-placeholder {
  color: transparent;
}
.tabs {
  margin-top: 50px;
  padding-bottom: 40px;
  background-color: #fff;
  position:relative;
			left:50px;
  /*width:400px;*/
  
  }

/*タブのスタイル*/
.tab_item {
  width:150px;
  height: 50px;
  border-bottom: 3px solid #979797;
  background-color: #5b9bd5;
  line-height: 50px;
  font-size: 16px;
  text-align: center;
  color: #ffffff;
  display: block;
  
  text-align: center;

  transition: all 0.2s ease;
  border-radius: 0.75em 0.75em 0px 0px;
  display: inline-block;

}
.tab_item:hover {
  opacity: 0.75;
}

/*ラジオボタンを全て消す*/
input[name="tab_item"] {
  display: none;
}

/*タブ切り替えの中身のスタイル*/
.tab_content {
  display: none;
  padding: 40px 40px 0;
  clear: both;
  overflow: hidden;
}


/*選択されているタブのコンテンツのみを表示*/
#all:checked ~ #all_content,
#programming:checked ~ #programming_content,
#design:checked ~ #design_content {
  display: block;
}

/*選択されているタブのスタイルを変える*/
.tabs input:checked + .tab_item {
  background-color: #d9d9d9;
  color: #fff;
}
</style>


// WEBPACK FOOTER //
// page_0041_master_user_detail_bulk_edit.vue?7e7268c2